"use strict";
var adaptStream = function (x) { return x; };
function setAdapt(f) {
    adaptStream = f;
}
exports.setAdapt = setAdapt;
function adapt(stream) {
    return adaptStream(stream);
}
exports.adapt = adapt;
//# sourceMappingURL=adapt.js.map


//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/@cycle/time/~/@cycle/run/lib/adapt.js
// module id = ../../../node_modules/@cycle/time/node_modules/@cycle/run/lib/adapt.js
// module chunks = 1